// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  width: 52rem;
  background: var(--white);
  border-left: 1px solid var(--grey-border);
  filter: drop-shadow(0 1.6rem 3.2rem rgba(97, 97, 97, 0.1)) drop-shadow(-0.8rem 0 1.6rem rgba(97, 97, 97, 0.2));
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 160;
}

.header {
  padding: 2.8rem 4rem 2.7rem;
  border-bottom: 0.1rem solid var(--primary-10);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  font-size: 1.6rem;
  line-height: 1.9rem;
  font-weight: 500;
  color: var(--black);
}

.icon-cancel {
  font-size: 2.4rem;
  color: var(--grey-icon);
  cursor: pointer;
}

.content {
  padding: 3rem 4rem;
  flex-grow: 1;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/right-popup/right-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,yCAAA;EACA,8GAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,2BAAA;EACA,6CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":[".popup {\n  width: 52rem;\n  background: var(--white);\n  border-left: 1px solid var(--grey-border);\n  filter: drop-shadow(0 1.6rem 3.2rem rgba(97, 97, 97, 0.1)) drop-shadow(-0.8rem 0 1.6rem rgba(97, 97, 97, 0.2));\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 160;\n}\n\n.header {\n  padding: 2.8rem 4rem 2.7rem;\n  border-bottom: 0.1rem solid var(--primary-10);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.title {\n  font-size: 1.6rem;\n  line-height: 1.9rem;\n  font-weight: 500;\n  color: var(--black);\n}\n\n.icon-cancel {\n  font-size: 2.4rem;\n  color: var(--grey-icon);\n  cursor: pointer;\n}\n\n.content {\n  padding: 3rem 4rem;\n  flex-grow: 1;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
